import { Button } from "react-migration/components/DeprecatedButton";
import { TemporaryModal } from "react-migration/components/Modal/TemporaryModal";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import classNames from "classnames";

interface BalanceWarningModalProps {
  isOpen: boolean;
  onCloseClick: () => void;
  onTopUpClick: () => void;
}

export const BalanceWarningModal = ({ isOpen, onCloseClick, onTopUpClick }: BalanceWarningModalProps) => {
  const { t } = useTranslation();

  return (
    <TemporaryModal
      isOpen={isOpen}
      title={t("sites.letters.payment_warning_modal.unable_to_complete_payment")}
      width="w-1/5 min-w-[450px]"
      headerClass="h-12 p-3"
      titleClass="font-semibold text-base leading-6"
      handleClose={onCloseClick}
    >
      <div className={classNames("flex", "flex-col", "gap-y-2")}>
        <div className={classNames("font-normal", "text-sm", "leading-5", "border-b", "border-neutral-300", "p-3")}>
          {t("sites.letters.payment_warning_modal.you_dont_have_enough_balance_to_buy_the_letters")}
        </div>
        <div className={classNames("flex", "justify-end", "gap-2", "pb-2", "pr-2")}>
          <Button.Secondary onClick={onCloseClick}>{t("sites.letters.payment_warning_modal.cancel")}</Button.Secondary>
          <Button.Primary onClick={onTopUpClick}>
            {t("sites.letters.payment_warning_modal.top_up_balance")}
          </Button.Primary>
        </div>
      </div>
    </TemporaryModal>
  );
};
